import { render, staticRenderFns } from "./R10_circle.vue?vue&type=template&id=0ebecb3a&scoped=true"
import script from "./R10_circle.vue?vue&type=script&lang=js"
export * from "./R10_circle.vue?vue&type=script&lang=js"
import style0 from "./R10_circle.vue?vue&type=style&index=0&id=0ebecb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebecb3a",
  null
  
)

export default component.exports